import { BehaviorSubject } from 'rxjs';

export class WireRecipientService {
  private readonly _wireRecipientId$: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private readonly _secureIsActive$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private readonly _accounts$: BehaviorSubject<Array<any>> =
    new BehaviorSubject<Array<any>>([]);

  getWireRecipientId(): BehaviorSubject<string> {
    return this._wireRecipientId$;
  }

  setWireRecipientId(wireRecipientId: string): void {
    this._wireRecipientId$.next(wireRecipientId);
  }

  setSecureIsActive(secureIsActive: boolean): void {
    this._secureIsActive$.next(secureIsActive);
  }

  getSecureIsActive(): BehaviorSubject<boolean> {
    return this._secureIsActive$;
  }

  setAccounts(accounts: Array<any>) {
    this._accounts$.next(accounts);
  }

  getAccounts(): BehaviorSubject<Array<any>> {
    return this._accounts$;
  }
}
